import React, { Fragment } from 'react';
import withCopyEdit from '../data-container';
import InfoBox from '../../components/info-box';
/**
 * Commerce & Activity side panel — under development.
 */
const CommerceActivityView = () => {
    return (React.createElement(Fragment, null,
        React.createElement(InfoBox, { type: "warning" }, "This section is under development.")));
};
const CommerceActivityContainer = withCopyEdit(CommerceActivityView);
export default CommerceActivityContainer;
